import React, { FC } from 'react';
import { Platform } from '@wix/ambassador-wixstudio-templates-v1-template/types';
import { Trans } from '@wix/wix-i18n-config';
import { Box, Text, TextProps } from '@wix/design-system';

type MadeByHeaderProps = {
  businessName: string;
  textSize: TextProps['size'];
  editorType: Platform;
};

const MadeByHeader: FC<MadeByHeaderProps> = ({
  businessName,
  textSize,
  editorType,
}) => {
  return (
    <Box textAlign="center" align="center" padding="6px 12px">
      <Text size={textSize}>
        <Trans
          i18nKey={
            editorType === Platform.WIX
              ? 'marketplace.view-template-page.made-by-wix-com-site'
              : 'marketplace.view-template-page.made-by'
          }
          values={{
            businessName,
          }}
        >
          <span>0</span>
          <Text size={textSize} weight="bold">
            1
          </Text>
          <span>2</span>
        </Trans>
      </Text>
    </Box>
  );
};

export default MadeByHeader;
